/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showing_This_Listing_Is_Now_HInputs */

const en_showing_this_listing_is_now_h = /** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing: This listing is now visible on your storefront.`)
};

const id_showing_this_listing_is_now_h = /** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditampilkan: Listing ini sekarang terlihat di etalase Anda.`)
};

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const es_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const fr_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const de_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const ja_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const zh_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const ar_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const it_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const ru_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const pt_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/** @type {(inputs: Showing_This_Listing_Is_Now_HInputs) => LocalizedString} */
const ko_showing_this_listing_is_now_h = en_showing_this_listing_is_now_h;

/**
* | output |
* | --- |
* | "Showing: This listing is now visible on your storefront." |
*
* @param {Showing_This_Listing_Is_Now_HInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const showing_this_listing_is_now_h = /** @type {((inputs?: Showing_This_Listing_Is_Now_HInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showing_This_Listing_Is_Now_HInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_showing_this_listing_is_now_h(inputs)
	if (locale === "es") return es_showing_this_listing_is_now_h(inputs)
	if (locale === "fr") return fr_showing_this_listing_is_now_h(inputs)
	if (locale === "de") return de_showing_this_listing_is_now_h(inputs)
	if (locale === "ja") return ja_showing_this_listing_is_now_h(inputs)
	if (locale === "zh") return zh_showing_this_listing_is_now_h(inputs)
	if (locale === "ar") return ar_showing_this_listing_is_now_h(inputs)
	if (locale === "id") return id_showing_this_listing_is_now_h(inputs)
	if (locale === "it") return it_showing_this_listing_is_now_h(inputs)
	if (locale === "ru") return ru_showing_this_listing_is_now_h(inputs)
	if (locale === "pt") return pt_showing_this_listing_is_now_h(inputs)
	return ko_showing_this_listing_is_now_h(inputs)
});